import type { ItemKind } from "../../../api/content/reviewDecoders";

/**
 * JSON definitions a review shows field by field (authoring-ui.md AU-8): steps, Workflows
 * and label lists. Prompts, skills, tools and artifacts are text, shown as line diffs
 * (`textFields.ts`).
 */
export const FIELD_DIFF_KINDS: ReadonlySet<ItemKind> = new Set<ItemKind>(["step", "workflow", "label_list"]);
